import { TApprovalWorkflow } from '@modules/users/types/organizations.types';
import { TCustomFieldValue } from '@modules/items';
import { evaluateConditions } from './evalApprovalRules.helper';

/**
 * Selects the first ApprovalWorkflow whose conditions match the given custom
 * field values. Returns undefined if no workflow matches (callers default to
 * all 3 phases, no rules).
 */
const resolveApprovalWorkflow = (
  approvalWorkflows: TApprovalWorkflow[] | undefined,
  customFieldValues: TCustomFieldValue[]
): TApprovalWorkflow | undefined => {
  if (!approvalWorkflows?.length) return undefined;

  for (const workflow of approvalWorkflows) {
    if (evaluateConditions(workflow.conditions, customFieldValues)) {
      return workflow;
    }
  }

  return undefined;
};

export default resolveApprovalWorkflow;
